angular.module('backOffice').constant('companyTypes', {
    Parent: 1,
    Associate: 2,
    WireDomestic: 3,
    WireInternational: 4,
    Ach: 5,
});
